// @flow
import React from "react";
import MainFilters from "../mainfilters";
import FiltersByTypology from "../filtersbytypology";
import "./searchpanel.css";

const SearchPanel = () => {
  return (
    <div className="search-wrapper">
      <MainFilters />
      <FiltersByTypology />
    </div>
  );
};

export default SearchPanel;



// WEBPACK FOOTER //
// ./src/components/searchpanel/index.js